// extracted by mini-css-extract-plugin
export default {"Footer":"Footer2U8XAPoGhlgO"};